import React, { useState } from 'react';
import { Monitor, Box } from 'lucide-react';
import WorkflowCockpit2D from './WorkflowCockpit2D';
import WorkflowCockpit3D from './WorkflowCockpit3D';

const WorkflowCockpit = () => {
  const [mode, setMode] = useState(() => localStorage.getItem('cockpit_mode') || '2d');

  const switchMode = (m) => {
    setMode(m);
    localStorage.setItem('cockpit_mode', m);
  };

  return (
    <div>
      {/* Mode switcher */}
      <div className="flex items-center justify-center mb-3">
        <div className="flex items-center bg-slate-800/70 border border-slate-700/50 rounded-xl p-1 gap-1">
          <button
            data-testid="mode-2d"
            onClick={() => switchMode('2d')}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              mode === '2d'
                ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/25'
                : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
            }`}
          >
            <Monitor className="w-4 h-4" />
            Vue 2D
          </button>
          <button
            data-testid="mode-3d"
            onClick={() => switchMode('3d')}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              mode === '3d'
                ? 'bg-cyan-600 text-white shadow-lg shadow-cyan-500/25'
                : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
            }`}
          >
            <Box className="w-4 h-4" />
            Vue 3D
          </button>
        </div>
      </div>

      {/* Render active view */}
      {mode === '2d' ? <WorkflowCockpit2D /> : <WorkflowCockpit3D />}
    </div>
  );
};

export default WorkflowCockpit;
